import { Accordion } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledFilters = styled(Accordion)`
  border: 0.5px solid black;
  margin-top: 10px;

  .accordion-body {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .form-group {
    width: 49%;
    display: flex;
    align-items: center;

    .form-label {
      width: 20%;
      margin-bottom: 0;
    }

    .form-input {
      width: 60%;
    }
  }
`;
